import { IAppConfig } from '@rccl/telemetry-events';
import { ENV_CONFIG } from '~environments/environment';
import { telemetryEndpoints } from './telemetry.config';

export const TelemetryDefaultConfig: IAppConfig = {
  appKey: ENV_CONFIG.APIGEE_APP_KEY,
  appId: ENV_CONFIG.TELEMETRY.APP_ID,
  appEnv: ENV_CONFIG.TELEMETRY.APP_ENV,
  appVers: '2021.01.28.1',
  batch: {
    batchSize: ENV_CONFIG.TELEMETRY.BATCH.SIZE,
    isEnabled: ENV_CONFIG.TELEMETRY.BATCH.ENABLED
  },
  debug: {
    isEnabled: ENV_CONFIG.TELEMETRY.DEBUG.ENABLED,
    isVerbose: ENV_CONFIG.TELEMETRY.DEBUG.VERBOSE,
    isConsoleCollapsed: ENV_CONFIG.TELEMETRY.DEBUG.CONSOLE_COLLAPSED
  },
  trackingUrl: ENV_CONFIG.TELEMETRY.TRACKING_URL,
  endpoints: telemetryEndpoints,
  disableTelemetry: ENV_CONFIG.TELEMETRY.DISABLED,
  vdsId: '',
  MAX_CACHE_AGE: 200000
};
